var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('div',{staticClass:"card"},[_c('h2',{staticClass:"card__title"},[_vm._v(_vm._s(_vm.$t('widget.tracking.title')))]),_c('TrackShipment',{attrs:{"reduced":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }